package com.veldekar.pages.log

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.PageContext
import com.veldekar.components.layouts.SessionPageLayout
import com.veldekar.components.logs.Log_2025_12_13_Day_1
import com.veldekar.components.widgets.SessionDayHeader
import com.veldekar.components.widgets.SessionMediaItem
import kotlinx.datetime.LocalDate

@Page(routeOverride = "/2025-12-13")
@Composable
public fun Log_2025_12_13(ctx: PageContext) {
    SessionPageLayout(
        ctx = ctx,
        title = "The Quokkafication of Ludwig Voss",
        ogTitle = "The Quokkafication of Ludwig Voss",
        date = LocalDate(2_025, 12, 13),
        ogDescription = "Once a feared half-orc. Now adorable. Barrowmen remain baffled.",
        ogImage = "images/quokkaInHandcuffs_preview.webp",
        ogImageWidth = 1_200,
        ogImageHeight = 630,
        ogImageAlt = "A hand-drawn illustration of a quokka wearing blue handcuffs. This is Ludwig Voss after Tuesday used Polymorph to turn him into a quokka and turned him over to the Barrowmen.",
    ) {
        SessionDayHeader(dayId = "shimmer-9", dateString = "Shimmer 9")
        Log_2025_12_13_Day_1()
        SessionMediaItem(
            image = "images/quokkaInHandcuffs_transparent.webp",
            linkImage = "images/quokkaInHandcuffs_transparent.webp",
            description = "A hand-drawn illustration of a quokka wearing blue handcuffs. This is Ludwig Voss after Tuesday used Polymorph to turn him into a quokka and turned him over to the Barrowmen.",
            width = 816,
            height = 1_080,
        )
    }
}
